let transientAuthData = null;

const AUTH_STORAGE_KEY = 'auth';

export const clearAllStorageData = () => {
  transientAuthData = null;

  try {
    localStorage.clear();
  } catch {
    // Storage may be unavailable in restricted browser contexts.
  }

  try {
    sessionStorage.clear();
  } catch {
    // Storage may be unavailable in restricted browser contexts.
  }
};

export const getStoredAuthData = () => {
  try {
    return JSON.parse(localStorage.getItem(AUTH_STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
};

export const getAuthData = () => {
  const storedAuthData = getStoredAuthData();
  return storedAuthData?.token ? storedAuthData : transientAuthData || {};
};

export const getAuthToken = () => {
  return getAuthData()?.token || null;
};

export const setStoredAuthData = (authData) => {
  transientAuthData = null;

  try {
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(authData));
  } catch {
    // Ignore write failures; callers still receive the auth data.
  }
};

export const setTransientAuthData = (authData) => {
  transientAuthData = authData;
};

export const removeStoredAuthData = () => {
  transientAuthData = null;

  try {
    localStorage.removeItem(AUTH_STORAGE_KEY);
  } catch {
    // Ignore storage cleanup errors.
  }
};
